import React from 'react'
import TextField from '@mui/material/TextField'

const CustomInput = (props) => {
    const shrink = props.shrink ? props.shrink.toString() : 'false'
    return !props.isDefault ? (
        <>
            <div className="customTextArea">
                <TextField
                    multiline
                    minRows={props.rows || 1}
                    maxRows={props.rowsMax || 4}
                    value={props.value}
                    autoFocus={props.autoFocus}
                    name={props.name}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                    InputProps={{
                        inputProps: props.inputProps,
                        startAdornment: props.startAdornment,
                        shrink: shrink,
                    }}
                    id={props.id}
                    label={props.label}
                    type={props.type}
                    size={props.size}
                    disabled={props.disabled}
                    variant="outlined"
                    placeholder={props.placeholder}
                    error={props.error}
                    helperText={props.helperText}
                />
            </div>
        </>
    ) : (
        <>
            <div className="customTextArea">
                <TextField
                    multiline
                    minRows={props.rows || 1}
                    maxRows={props.rowsMax || 4}
                    type="text"
                    variant="outlined"
                    name={props.name}
                    label={props.label}
                    value={props.value}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                    onFocus={props.onFocus}
                    error={props.error}
                    helperText={props.helperText}
                    placeholder={props.placeholder}
                />
            </div>
        </>
    )
}

export default CustomInput
